import React from "react";
import {useTranslation} from "react-i18next";
import {
    Grid,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Typography
} from "@material-ui/core";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {IShipmentSummary} from "../../pages/SingleShipmentTrackingPage";
import Loader from "../core/Loader";
import {ArrowForwardIos, InfoOutlined} from "@material-ui/icons";
import withWidth, {WithWidthProps} from "@material-ui/core/withWidth";
import {useNavigate, useLocation} from "react-router-dom";
import {SHIPMENT_DETAILS_PAGE_PATH} from "../../layouts/navigation/Navigator";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        lineItemContextContainer: {
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center"
        },
        shipmentInfoContainer: {

            display: "flex",
            alignItems: "center",
            flex: 1,
            overflow: "hidden"
        },
        innerContainer: {width: "60vw", display: "flex", overflow: "hidden", alignItems: "center"},
        shipmentInfoCard: {
            flex: 1
        },
        caption: {
            fontWeight: "bold",
            marginRight: 5
        },
        value: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: '11rem'
        }
    }),
);


interface IShipmentInfoCard {
    shipmentSummary?: IShipmentSummary
}


const ShipmentInfoCard: React.FC<IShipmentInfoCard & WithWidthProps> = ({shipmentSummary, width}) => {
    const classes = useStyles();

    const navigate = useNavigate();
    const location = useLocation();

    return <Paper className={classes.root}>
        <List>
            <ListItem button onClick={() => navigate({
                pathname: `${SHIPMENT_DETAILS_PAGE_PATH}/${shipmentSummary?.uuid}`,
                search: `redirect=${encodeURIComponent(location.pathname + location.search)}`

            })}>
                <ListItemIcon>
                    <InfoOutlined fontSize="large"/>
                </ListItemIcon>
                <ListItemText
                    primary={<CardItem shipmentSummary={shipmentSummary} width={width}/>}
                />
                <ListItemSecondaryAction>
                    <IconButton size="medium" color="primary">
                        <ArrowForwardIos/>
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>

        </List>
    </Paper>
};


const CardItem: React.FC<IShipmentInfoCard & WithWidthProps> = ({shipmentSummary, width}) => {

    const {t} = useTranslation();

    if (!shipmentSummary) {
        return <Loader/>;
    }

    const {shipper, consignee, weight, weightUnit, volume, volumeUnit} = shipmentSummary;


    return <React.Fragment>
        <Grid container justifyContent="center"
              alignItems="center">
            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("shipment.shipper")} value={shipper} width={width}/>
                <InfoCardLine property={t("shipment.consignee")} value={consignee} width={width}/>
            </Grid>

            <Grid item xs={12} sm={6}>
                <InfoCardLine property={t("shipment.cargo")} width={width}/>
                <InfoCardLine property={t("shipment.weight", {weightUnit})} value={weight} width={width}/>
                <InfoCardLine property={t("shipment.volume", {volumeUnit})} value={volume} width={width}/>
            </Grid>

        </Grid>

    </React.Fragment>
};

export const InfoCardLine: React.FC<{ property?: React.ReactNode, value?: React.ReactNode } & WithWidthProps> = ({property, value}) => {

    const classes = useStyles();


    return <div className={classes.shipmentInfoContainer}>
        <div className={classes.innerContainer}>
            {property && <Typography
                variant="body1"
                color="textPrimary"
                className={classes.caption}
            >
                {property}:
            </Typography>}
            <Typography
                noWrap={true}
                variant="body2"
                color="textPrimary"
            >
                {value}
            </Typography>
        </div>

    </div>
};


export default withWidth()(ShipmentInfoCard);